import { createClient } from '@supabase/supabase-js'
// remote server
export const supabase = createClient('https://jqclwufndjwkioascfpd.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpxY2x3dWZuZGp3a2lvYXNjZnBkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTIyODM1NjQsImV4cCI6MjAyNzg1OTU2NH0.DXAj4-XZVCwN01qHNilafBxBlwcBW3CU9CI1vWhw8Vc')
// location server
// export const supabase = createClient('http://127.0.0.1:54321', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZS1kZW1vIiwicm9sZSI6ImFub24iLCJleHAiOjE5ODM4MTI5OTZ9.CRXP1A7WOeoJeXxjNni43kdQwgnWNReilDMblYTn_I0')

